module.exports = __webpack_public_path__ + "img/creative-menu-block-yellow.a036b025.png";